module.exports = __webpack_public_path__ + "img/logo-light.83d8a3cc.png";